import { UPLOAD_FILE_URL, UPLOAD_FILE_V2_URL, GET_PRE_SIGNED_UPLOAD_URL } from '@services/urls/files';
import * as CsrHttpService from '@http/csr-http.service';
import { hasWindow } from '@services/http.service';
import * as SsrHttpService from '@http/ssr-http.service';

export const fileUploadHandler = (bucket, file, key, ctx = null) => {
    const url = UPLOAD_FILE_URL();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', key);
    formData.append('bucket', bucket);
    if (hasWindow()) {
        return CsrHttpService.postWithAuth(url, formData);
    }
    return SsrHttpService.postWithAuth(url, formData, ctx);
};

export const fileUploadHandlerV2 = (bucket, file, key, ctx = null) => {
    const url = UPLOAD_FILE_V2_URL();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', key);
    formData.append('bucket', bucket);
    if (hasWindow()) {
        return CsrHttpService.postWithAuth(url, formData);
    }
    return SsrHttpService.postWithAuth(url, formData, ctx);
};

export const getPresignedUploadUrl = (bucket, key, expiresAt, ctx = null) => {
    const url = GET_PRE_SIGNED_UPLOAD_URL(bucket, key, expiresAt);
    if (hasWindow()) return CsrHttpService.getWithAuth(url);
    return SsrHttpService.getWithAuth(url, ctx);
};